import { render, staticRenderFns } from "./SignaturePreview.vue?vue&type=template&id=fbdae414&scoped=true&"
import script from "./SignaturePreview.vue?vue&type=script&lang=js&"
export * from "./SignaturePreview.vue?vue&type=script&lang=js&"
import style0 from "./SignaturePreview.vue?vue&type=style&index=0&id=fbdae414&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdae414",
  null
  
)

export default component.exports